import type { ReactNode } from 'react'
import type { Order } from '../../types'
import { formatTRY } from '../../utils/money'
import { CheckIcon, ShoppingBagIcon } from '../icons'
import './KioskBoard.css'

/**
 * Kasanın Kiosk sekmesi (1 Kas 2026, kullanıcı): kiosk siparişleri üç sütunda.
 * Ödeme bekleyene dokununca sipariş sepete yüklenir, ödeme sağdan alınır;
 * hazırlanan "Hazır" ile, teslim bekleyen "Teslim edildi" ile ilerler.
 * Kullanıcı: "çok açık, sade, gereksiz hiçbir şey olmadan".
 */
export function KioskBoard({
  waiting,
  preparing,
  toHand,
  activeId,
  busyId,
  onPick,
  onReady,
  onHand,
}: {
  waiting: Order[]
  preparing: Order[]
  toHand: Order[]
  activeId: string | null
  busyId: string | null
  onPick: (o: Order) => void
  onReady: (o: Order) => void
  onHand: (o: Order) => void
}) {
  return (
    <div className="kboard">
      <Column tone="pay" title="Ödeme bekleyen" count={waiting.length}>
        {waiting.map((o) => (
          <button
            key={o.id}
            type="button"
            className={`kcard kcard--pick ${activeId === o.id ? 'is-on' : ''}`}
            onClick={() => onPick(o)}
          >
            <span className="kcard__main">
              <Head o={o} />
              <span className="kcard__sub">
                {o.itemCount} ürün, {formatTRY(o.totalKurus)}
              </span>
            </span>
          </button>
        ))}
      </Column>

      <Column tone="prep" title="Hazırlanan" count={preparing.length}>
        {preparing.map((o) => (
          <div key={o.id} className="kcard">
            <span className="kcard__main">
              <Head o={o} />
            </span>
            <button type="button" className="kcard__act kcard__act--ready" disabled={busyId === o.id} onClick={() => onReady(o)}>
              <CheckIcon />
              Hazır
            </button>
          </div>
        ))}
      </Column>

      <Column tone="hand" title="Teslim bekleyen" count={toHand.length}>
        {toHand.map((o) => (
          <div key={o.id} className="kcard">
            <span className="kcard__main">
              <Head o={o} />
            </span>
            <button type="button" className="kcard__act kcard__act--hand" disabled={busyId === o.id} onClick={() => onHand(o)}>
              <ShoppingBagIcon />
              Teslim edildi
            </button>
          </div>
        ))}
      </Column>
    </div>
  )
}

function Column({ tone, title, count, children }: { tone: string; title: string; count: number; children: ReactNode }) {
  return (
    <section className={`kcol kcol--${tone}`} aria-label={title}>
      <header className="kcol__head">
        <span className="kcol__dot" aria-hidden="true" />
        <h3>{title}</h3>
        <span className="kcol__count">{count}</span>
      </header>
      <div className="kcol__list">{count === 0 ? <p className="kcol__empty">Sipariş yok</p> : children}</div>
    </section>
  )
}

function Head({ o }: { o: Order }) {
  return (
    <span className="kcard__head">
      <b>#{o.takeawayNo ?? '-'}</b>
      {o.pickupCode && <span className="kcard__code">{o.pickupCode}</span>}
    </span>
  )
}
